import { createSelector } from '@ngrx/store';
import { selectStaticDataState } from '../static-data.reducer';
import * as fromGoogleAPIKeyReducer from '../reducers/google-api-key.reducer';

export const selectGoogleAPIKeyState = createSelector(
  selectStaticDataState,
  state => state[fromGoogleAPIKeyReducer.googleAPIKeyFeatureKey]
);

export const selectGoogleAPIKey = createSelector(
  selectGoogleAPIKeyState,
  fromGoogleAPIKeyReducer.getGoogleAPIKey
);

export const selectGoogleAPIKeyLoading = createSelector(
  selectGoogleAPIKeyState,
  fromGoogleAPIKeyReducer.getGoogleAPIKeyLoading
);

export const selectGoogleAPIKeyError = createSelector(
  selectGoogleAPIKeyState,
  fromGoogleAPIKeyReducer.getGoogleAPIKeyError
);

